export default __webpack_public_path__ + "static/media/bg-masthead-1-480w.e0b218fc.webp";